import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';
import type { SpaceMemoryItem } from '../useGetSpaceMemory/useGetSpaceMemory.fetch';

export type CreateSpaceMemoryFetchParams = {
	spaceId: string;
	content: string;
	cloudId: string;
	product: string;
	experienceId: string;
};

export const createSpaceMemoryFetchAction = ({
	spaceId,
	content,
	cloudId,
	product,
	experienceId,
}: CreateSpaceMemoryFetchParams): Promise<SpaceMemoryItem> =>
	performHttpFetch<SpaceMemoryItem>({
		path: `${SPACES_API_PATH}/${spaceId}/memory`,
		options: {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
			body: JSON.stringify({ content }),
		},
	});
